// extracted by mini-css-extract-plugin
module.exports = {"companiesList":"styles_companiesList__1HG75","companyItem":"styles_companyItem__1CBe9"};